import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"newspaper-1, guide, info, faq, book"} maskId="square-filled-radius-0-stroke-1-IconNewspaper1"><path d="M11.5 5.41504L2 3.91504V18.9274L11.5 20.4274V5.41504Z" fill="currentColor"/><path d="M12.5 5.41504V20.4274L22 18.9274V3.91504L12.5 5.41504Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconNewspaper1;
